import React from "react"
import { useTranslation } from "react-i18next"
import Box from "@mui/material/Box"
import ButtonBase from "@mui/material/ButtonBase"
import CameraAltOutlinedIcon from "@mui/icons-material/CameraAltOutlined"
import PhotoLibraryOutlinedIcon from "@mui/icons-material/PhotoLibraryOutlined"
import { useConfig } from "../../hooks/useConfig"

export type CaptureMode = "camera" | "upload"

interface CaptureSourceToggleProps {
  mode: CaptureMode
  onChange: (mode: CaptureMode) => void
}

export default function CaptureSourceToggle({ mode, onChange }: CaptureSourceToggleProps) {
  const { t } = useTranslation()
  const theme = useConfig().theme

  const segments: { key: CaptureMode; label: string; icon: React.ReactNode }[] = [
    { key: "camera", label: t("capture.camera"), icon: <CameraAltOutlinedIcon sx={{ fontSize: 20, mr: 0.75 }} /> },
    { key: "upload", label: t("capture.photos"), icon: <PhotoLibraryOutlinedIcon sx={{ fontSize: 20, mr: 0.75 }} /> },
  ]

  return (
    <Box
      sx={{
        display: "flex",
        border: `2px solid ${theme.textColor}`,
        borderRadius: 999,
        overflow: "hidden",
        mb: 2,
        mx: "auto",
        width: "fit-content",
      }}
    >
      {segments.map((segment) => {
        const selected = mode === segment.key
        return (
          <ButtonBase
            key={segment.key}
            onClick={() => onChange(segment.key)}
            sx={{
              display: "flex",
              alignItems: "center",
              px: 2.5,
              py: 1,
              fontSize: 14,
              fontWeight: 600,
              transition: "background-color 0.2s, color 0.2s",
              bgcolor: selected ? theme.textColor : "transparent",
              color: selected ? theme.highestContrastBackgroundColor : theme.textColor,
            }}
          >
            {segment.icon}
            {segment.label}
          </ButtonBase>
        )
      })}
    </Box>
  )
}
